//VIDEO-BASED LEARNING
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//COMPONENT DEPENDENCIES
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import PageHeader from '../../components/PageHeader'
import FullWidthImage from '../../components/FullWidthImage'
import TextBlock from '../../components/textblock'
import ContentBlock from '../../components/ContentBlock'
import '../../styles/newsEvents.css'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************  
const videoBasedLearningPage = ({data}) => {
    
    const videoBasedLearning = data.video_based_learning.edges
    
    return (
        
        <div>
			
             <Helmet>
                   <title>Video-Based Learning</title>
                    <meta name="description" content="Annual NJCCIC cyber security conference for women in cyber security and IT"/>
            </Helmet>
            <Heading/>

            <Navbar/>

            {videoBasedLearning.map(({ node: {page_title} }) => (

                <div class="container-fluid">
					
					<PageHeader elementClass="pageHeader centerText" title={page_title}/>
        
                    <div class="container containerWidth">
                        
                        <div class="row">
							
							<div class="col-xs-10 offset-xs-1 col-md-9 offset-md-0 borderBottom">
								
								<iframe id="mrgeraghty" class="introPadding noBorder secondaryVideo" width="50%" height="315" src="https://www.youtube.com/embed/ZJWyBPk3k64" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
																							
							</div>
                            
                        </div>
                        
                    </div>
        
                </div>

            ))}

            <Footer/>

        </div>
    
    )
    
}
//*******************************************************************  
export const query = graphql`
    query {
        video_based_learning: allButterPage(filter: {slug: { eq: "video-based-learning" } }) {
            edges {
                node {
                    slug
                    page_title
                }
            }
            
        }
    }
`
//*******************************************************************  
export default videoBasedLearningPage